<template>
	<main-layout>
		<div clas="table-row">
			<select v-model="profileSelected" v-on:change="refresh">
				<option disabled value="">Please select one</option>
				<template v-for="(profile,membershipId) of profiles">
					<option v-bind:value="profile.profile.membershipType">{{getMembershipTypeName(profile.profile.membershipType)}}</option>
				</template>
			</select>
			<select v-model.number="classType" v-on:change="processItems" multiple>
				<option value="3">Titan</option>
				<option value="2">Hunter</option>
				<option value="1">Warlock</option>
				<option value="0">Unknown</option>
			</select>
			<select v-model.number="tierType" v-on:change="processItems" multiple>
				<option value="1">Currency</option>
				<option value="2">Basic</option>
				<option value="3">Common</option>
				<option value="4">Rare</option>
				<option value="5">Superior</option>
				<option value="6">Exotic</option>
			</select>
			<select v-model.number="categoryHashes" v-on:change="processItems" multiple>
				<template v-for="(itemCategory,hash) of DestinyItemCategoryDefinition">
					<option v-bind:value="hash" v-if="itemCategory.shortTitle !== '' && itemCategory.shortTitle.startsWith('#') === false">{{ hash }} - {{ itemCategory.shortTitle }}</option>
				</template>
			</select>
			<input type="button" v-on:click="refresh" value="Refresh" />
		</div>
		<div class="content-body">
			<div clas="table-row">
				<div v-for="item in items" class="table-cell">
						<v-popover trigger="hover">
								<item-node :data="item" class="tooltip-target"></item-node>
								<template slot="popover" class="popper" v-if="typeof item.itemHash !== 'undefined' && getItemDef(item)">
									<tooltip :data="item" :item-def="DestinyInventoryItemDefinition[item.itemHash]" :type="'item'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item) && getProgressionDef(item).factionHash">
									<tooltip :data="item" :item-def="getFactionDef(getProgressionDef(item))" :type="'faction'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item)">
									<tooltip :data="item" :item-def="getProgressionDef(item)" :type="'progression'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else-if="typeof item.factionHash !== 'undefined' && getFactionDef(item)">
									<tooltip :data="item" :item-def="getFactionDef(item)" :type="'faction'"></tooltip>
								</template>
								<template slot="popover" class="popper" v-else></template>
								<!-- </popper> -->
							</v-popover>
					<!-- <popper trigger="hover" :options="{placement: 'bottom'}">
						<div class="popper" v-if="typeof item.itemHash !== 'undefined' && getItemDef(item)">
							<tooltip :data="item" :item-def="DestinyInventoryItemDefinition[item.itemHash]" :type="'item'"></tooltip>
						</div>
						<div class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item) && getProgressionDef(item).factionHash">
							<tooltip :data="item" :item-def="getFactionDef(getProgressionDef(item))" :type="'faction'"></tooltip>
						</div>
						<div class="popper" v-else-if="typeof item.progressionHash !== 'undefined' && getProgressionDef(item)">
							<tooltip :data="item" :item-def="getProgressionDef(item)" :type="'progression'"></tooltip>
						</div>
						<div class="popper" v-else-if="typeof item.factionHash !== 'undefined' && getFactionDef(item)">
							<tooltip :data="item" :item-def="getFactionDef(item)" :type="'faction'"></tooltip>
						</div>
						<div class="popper" v-else></div>

						<item-node :data="item" slot="reference"></item-node>
					</popper> -->
				</div>
			</div>
		</div>
	</main-layout>
</template>

<style>
	h2 {
		cursor: pointer;
	}

	h2 span {
		font-size: 1.1em;
		font-weight: normal;
	}

	.acquired {
		opacity: 0.3;
	}

	.table-cell>span {
		display: inline-block
	}

	.content-body {
		display: grid;
		overflow-y: scroll;
		text-align: center;
		height: 100%;
	}

	.scroller {
		/* height: 100%; */
		height: calc(100% - 50px);
		width: 100%;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 2em;
	}

	.items {
		display: table;
		font-family: Arial, Helvetica, sans-serif;
	}

	.table-row {
		display: table-row;
	}

	.table-cell {
		display: inline-block;
		vertical-align: middle;
	}

	.table-cell.progression,
	.table-cell.added,
	.table-cell.removed,
	.table-cell.modified {
		padding: 0.5em 1em;
	}

	.table-cell.progression {
		background: rgba(200, 200, 200, 0.5)
	}

	.table-cell.added {
		background: rgba(0, 255, 0, 0.25)
	}

	.table-cell.removed {
		background: rgba(255, 0, 0, 0.25)
	}

	.table-cell.modified {
		background: rgba(0, 0, 255, 0.25)
	}

	.table-cell.progression::before,
	.table-cell.added::before,
	.table-cell.removed::before,
	.table-cell.modified::before {
		font-weight: bold;
		font-family: Arial, Helvetica, sans-serif;
		font-size: 46px;
		vertical-align: top;
	}

	.table-cell.progression::before {
		content: "%";
	}

	.table-cell.added::before {
		content: "+";
	}

	.table-cell.removed::before {
		content: "−";
	}

	.table-cell.modified::before {
		content: "#";
	}

	.table {
		display: table;
	}
	.v-popover {
		display: inline;
	}
	.tooltip {
		display: block!important;
		z-index: 10000
	}

	.tooltip .tooltip-arrow {
		width: 0;
		height: 0;
		border-style: solid;
		position: absolute;
		margin: 5px;
		border-color: #000;
		z-index: 1
	}

	.tooltip[x-placement^=top] {
		margin-bottom: 5px
	}

	.tooltip[x-placement^=top] .tooltip-arrow {
		border-width: 5px 5px 0;
		border-left-color: transparent!important;
		border-right-color: transparent!important;
		border-bottom-color: transparent!important;
		bottom: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0
	}

	.tooltip[x-placement^=bottom] {
		margin-top: 5px
	}

	.tooltip[x-placement^=bottom] .tooltip-arrow {
		border-width: 0 5px 5px;
		border-left-color: transparent!important;
		border-right-color: transparent!important;
		border-top-color: transparent!important;
		top: -5px;
		left: calc(50% - 5px);
		margin-top: 0;
		margin-bottom: 0
	}

	.tooltip[x-placement^=right] {
		margin-left: 5px
	}

	.tooltip[x-placement^=right] .tooltip-arrow {
		border-width: 5px 5px 5px 0;
		border-left-color: transparent!important;
		border-top-color: transparent!important;
		border-bottom-color: transparent!important;
		left: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0
	}

	.tooltip[x-placement^=left] {
		margin-right: 5px
	}

	.tooltip[x-placement^=left] .tooltip-arrow {
		border-width: 5px 0 5px 5px;
		border-top-color: transparent!important;
		border-right-color: transparent!important;
		border-bottom-color: transparent!important;
		right: -5px;
		top: calc(50% - 5px);
		margin-left: 0;
		margin-right: 0
	}

	.tooltip[aria-hidden=true] {
		visibility: hidden;
		opacity: 0;
		transition: opacity .15s, visibility .15s
	}

	.tooltip[aria-hidden=false] {
		visibility: visible;
		opacity: 1;
		transition: opacity .15s
	}

	.tooltip.popover .popover-arrow {
		border-color: #f9f9f9
	}
</style>

<script>
	import Vue from 'vue'
	import MainLayout from '../layouts/Main.vue'
	import Paginate from '../components/Paginate.vue'
	import Item from '../components/Item.vue'
	import Tooltip from '../components/Tooltip.vue'
	import VTooltip from 'v-tooltip'
	Vue.use(VTooltip)
	import drive from '../shared/drive';
	for (let hash in DestinyFactionDefinition) {
		if (typeof DestinyFactionDefinition[hash].progressionHash === "number") {
			if (DestinyProgressionDefinition[DestinyFactionDefinition[hash].progressionHash]) {
				DestinyProgressionDefinition[DestinyFactionDefinition[hash].progressionHash].factionHash = hash;
				// console.log(`factionHash: ${hash}, progressionHash: ${DestinyFactionDefinition[hash].progressionHash}`)
			}
		}
	}


	export default {
		components: {
			'main-layout': MainLayout,
			'paginate': Paginate,
			'item-node': Item,
			'tooltip': Tooltip,
		},
		data: function () {
			return {
				DestinyInventoryItemDefinition: DestinyInventoryItemDefinition,
				DestinyFactionDefinition: DestinyFactionDefinition,
				DestinyProgressionDefinition: DestinyProgressionDefinition,
				DestinyItemCategoryDefinition: DestinyItemCategoryDefinition,
				DestinyVendorDefinition: DestinyVendorDefinition,
				history: [],
				items: [],
				membershipTypes: [],
				profiles: {},
				profileSelected: "",
				classType: [0, 1, 2, 3],
				tierType: [5],
				categoryHashes: [],
				itemsPerPage: Math.floor((document.documentElement.clientHeight - 117) / 66)
			};
		},
		created() {
			let self = this;
			drive.postAuth(function () {
				self.getHistory()
			})
		},
		methods: {
			getMembershipTypeName(membershipType) {
				if (membershipType === 1) {
					return "XBOX";
				}
				if (membershipType === 2) {
					return "PLAYSTATION";
				}
				if (membershipType === 4) {
					return "BLIZZARD";
				}
			},
			processItems: function () {
				console.log(this.tierType, this.classType, this.history.length)
				let uniqueItems = {};
				for (let historyItem of this.history) {
					if (historyItem.added) {
						for (let item of historyItem.added) {
							if (uniqueItems[item.itemHash]) {
								uniqueItems[item.itemHash].quantity += item.quantity || 1;
							} else {
								var copy = Object.assign({}, item);
								uniqueItems[item.itemHash] = copy;
								uniqueItems[item.itemHash].quantity = uniqueItems[item.itemHash].quantity || 1;
								delete uniqueItems[item.itemHash].primaryStat;
								delete uniqueItems[item.itemHash].objectives;
							}
						}
					}
				}
				this.items.length = 0;
				if (this.classType.length || this.tierType.length || this.categoryHashes.length) {
					for (let itemHash in uniqueItems) {
						let match = 0;
						if (this.classType.length) {
							match++;
							if (this.classType.indexOf(Math.abs(this.getItemDef(uniqueItems[itemHash]).classType - 3)) > -1) {
								match--;
							}
						}
						if (this.tierType.length) {
							match++;
							if (this.tierType.indexOf(this.getItemDef(uniqueItems[itemHash]).inventory.tierType) > -1) {
								match--;
							}
						}
						if (this.categoryHashes.length) {
							match++;
							for (let categoryHash of this.categoryHashes) {
								if (this.getItemDef(uniqueItems[itemHash]).itemCategoryHashes && this.getItemDef(uniqueItems[itemHash]).itemCategoryHashes
									.indexOf(categoryHash) > -1) {
									match--;
									break;
								}
							}
						}
						if (match === 0) {
							this.items.push(uniqueItems[itemHash]);
						}
					}
				}
				let self = this;
				this.items.sort(function (a, b) {
					let adef = self.getItemDef(a);
					let bdef = self.getItemDef(b);
					let ahashes = [];
					let bhashes = [];
					for (let categoryHash of adef.itemCategoryHashes) {
						ahashes.push(Math.abs(categoryHash - 100))
					}
					for (let categoryHash of bdef.itemCategoryHashes) {
						bhashes.push(Math.abs(categoryHash - 100))
					}
					ahashes.sort();
					bhashes.sort();
					let aname = Math.abs(adef.classType - 3) + ahashes.join("") + adef.inventory.tierType + ("" + a.quantity).padStart(
						10, "0");
					let bname = Math.abs(bdef.classType - 3) + bhashes.join("") + bdef.inventory.tierType + ("" + b.quantity).padStart(
						10, "0");
					aname = aname.padStart(6, "0");
					bname = bname.padStart(6, "0");
					a.name = aname;
					b.name = bname;
					if (adef.itemTypeDisplayName === bdef.itemTypeDisplayName) {
						// return (aname + a.quantity).localeCompare(bname + b.quantity)
					}
					if (aname === bname) {
						return adef.itemTypeDisplayName.localeCompare(bdef.itemTypeDisplayName);
					}
					return aname.localeCompare(bname);
				});
				console.log(this.items)
			},
			refresh: function () {
				let self = this;
				drive.getFile(drive.files[`history${self.profileSelected}`]).then(function (fileDetails) {
					if (typeof fileDetails.data !== "undefined") {
						// self.history.length = 0;
						self.history = fileDetails.data.history;
					}
					self.processItems();
				})
			},
			getHistory: function () {
				let self = this;
				drive.getFile(drive.files.profiles).then(function (fileDetails) {
					if (fileDetails && fileDetails.data) {
						for (let membershipId of Object.keys(fileDetails.data)) {
							self.profiles[membershipId] = fileDetails.data[membershipId];
							if (self.membershipTypes.indexOf(self.profiles[membershipId].profile.membershipType) === -1) {
								self.membershipTypes.push(self.profiles[membershipId].profile.membershipType);
							}
							self.profileSelected = self.profiles[membershipId].profile.membershipType;
						}
						drive.getFile(drive.files[`history${self.profileSelected}`]).then(function (fileDetails) {
							if (typeof fileDetails.data !== "undefined") {
								// self.history.length = 0;
								self.history = fileDetails.data.history;
							}
							self.processItems();
						})
					}
				})
			},
			getItemDef(item) {
				return DestinyInventoryItemDefinition[item.itemHash];
			},
			getProgressionDef(item) {
				return DestinyProgressionDefinition[item.progressionHash];
			},
			getFactionDef(item) {
				return DestinyFactionDefinition[item.factionHash];
			}
		}
	}
</script>


// WEBPACK FOOTER //
// History.vue?5ecd37d2